import { render, staticRenderFns } from "./CandidateCourseItem.vue?vue&type=template&id=285c21ae&scoped=true&lang=pug&"
import script from "./CandidateCourseItem.vue?vue&type=script&lang=js&"
export * from "./CandidateCourseItem.vue?vue&type=script&lang=js&"
import style0 from "./CandidateCourseItem.vue?vue&type=style&index=0&id=285c21ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285c21ae",
  null
  
)

export default component.exports